import { __awaiter, __generator } from "tslib";
import { logError } from '@office-start/telemetry-service';
import { Subject } from 'rxjs';
var AccessTokenDefaultExpiryTimeInMs = 3600000;
var BasePwaAccessTokenService = /** @class */ (function () {
    function BasePwaAccessTokenService(defaultTokenFormat, defaultTokenSource) {
        this.defaultTokenFormat = defaultTokenFormat;
        this.defaultTokenSource = defaultTokenSource;
        this._reauth = new Subject();
        this.reauthComplete = this._reauth.asObservable();
    }
    BasePwaAccessTokenService.prototype.init = function (defaultTokenFormat, defaultTokenSource) {
        this.defaultTokenFormat = defaultTokenFormat;
        this.defaultTokenSource = defaultTokenSource;
    };
    BasePwaAccessTokenService.prototype.getDefaultExpiry = function () {
        return new Date().getTime() + AccessTokenDefaultExpiryTimeInMs;
    };
    // NOTE: Never rejects. Always resolves with an object indicating success
    BasePwaAccessTokenService.prototype.getAccessToken = function (tokenConsumer, forceFetch, resourceUrl, allowInteractive, capDialogData, clientId, scope, claims, claimsChallenge) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!tokenConsumer) {
                    return [2 /*return*/, Promise.resolve({
                            success: false,
                            token: '',
                            format: this.defaultTokenFormat,
                            source: this.defaultTokenSource,
                            error: new Error('invalid tokenConsumer'),
                        })];
                }
                return [2 /*return*/, this.getAccessTokenResponse(tokenConsumer, forceFetch, resourceUrl, allowInteractive, capDialogData, clientId, scope, claims, claimsChallenge)
                        .then(function (tokenResponse) {
                        if (!tokenResponse || !tokenResponse.token) {
                            return {
                                success: false,
                                token: '',
                                format: _this.defaultTokenFormat,
                                source: _this.defaultTokenSource,
                                error: new Error('Empty token returned'),
                            };
                        }
                        return tokenResponse;
                    })
                        .catch(function (error) {
                        logError({
                            eventName: 'GetPwaAccessToken',
                            message: "PwaAccessTokenService.getAccessToken:".concat(error),
                        });
                        return {
                            success: false,
                            token: '',
                            format: _this.defaultTokenFormat,
                            source: _this.defaultTokenSource,
                            error: error,
                        };
                    })];
            });
        });
    };
    return BasePwaAccessTokenService;
}());
export { BasePwaAccessTokenService };
//# sourceMappingURL=BasePwaAccessTokenService.js.map